<template>
    <transition name="dropdownx">
        <div ref="options"
             :class="{'hide-content':!dropdownVisible}"
             :style="{'left':`${leftx}px`}"
             class="con-vs-dropdown--menu vs-dropdown-menu">
            <div class="vs-dropdown--custom vs-dropdown--menu" :style="{'width': `${width}px`}">
                <slot></slot>
            </div>
            <div style="top:10px;" ref="menuAfter" class="vs-dropdown-right--menu--after">
            </div>

        </div>
    </transition>
</template>

<script>
export default {
    name: "Dropdownx",
    data(){
        return {
            dropdownVisible: true,
        }
    },
    props:{
        leftx:{
            type:[Number,String],
        },
        topx:{
            type:[Number,String],
        },
        width:{
            type:[Number,String],
            default:550,
        },

    }
};
</script>

<style scoped>
.hide-content{
    display: none;
}
</style>
